import React from 'react'

export default function Transaction() {
  return (
    <div className='h-screen'>Transaction</div>
  )
}
